// One W / D / L box of a team's form (the League Table's Form column, the Bio's team card). With
// ?live=1 it is that game: press and move to drag it out as the match, onto empty canvas or onto a
// module that takes a match (Ben, 2026-10-31) — the same drag as a Match Results score.

import type { PointerEvent as ReactPointerEvent } from "react";
import { startMatchCardDragOnMove } from "../canvas/menu-drag.js";
import { LIVE } from "../live/flag.js";
import { matchOfResult } from "../live/match.js";
import type { FormGame } from "./league-table-view.js";

export function FormDot({ game, competitionId, season }: { game: FormGame; competitionId: number | null; season: string | null }) {
  const match = LIVE && competitionId !== null ? matchOfResult(game.fixture, competitionId, season ?? undefined) : null;
  const onPress = (e: ReactPointerEvent<HTMLSpanElement>) => {
    if (!match || window.innerWidth <= 768 || e.button !== 0) return;
    // Not the row's own team drag.
    e.stopPropagation();
    startMatchCardDragOnMove(e.nativeEvent, match);
  };
  return (
    <span className={`form-dot form-${game.result}${match ? " form-dot-draggable" : ""}`} data-tooltip={game.text} onPointerDown={onPress}>
      {game.result}
    </span>
  );
}
